
import RangeCalendar from './RangeCalendar';
import ScrollCalendar from './ScrollCalendar';
import SingleCalendar from './SingleCalendar';
import { CalendarRange, CalendarView } from './type';

import './index.scss';

interface CalendarProps {
  className?: string;
  date?: Date | CalendarRange;
  view?: CalendarView;
  setView?: (view:CalendarView)=>void;
  tileContent?: (date: Date | undefined, view: CalendarView) => React.ReactNode;
  onChange?:(date:Date | CalendarRange, method?:CalendarView)=>void;
  min?: Date;
  max?: Date;
  onClose?: () => void;
  viewSelector?: boolean;
  selectRange?: boolean;
  scroll?: boolean;
}

export default function Calendar({
  className = '', date: selectedDate, view, setView = () => { }, tileContent, onChange = () => { }, onClose, viewSelector = true,
  min = new Date('2000-01-01'), max = new Date('2099-11-31'), selectRange = false, scroll = false,
}: CalendarProps) {
  if (scroll) {
    return (
      <ScrollCalendar
        className={className}
        date={selectedDate as CalendarRange}
        onChange={onChange}
        min={min}
        max={max}
      />
    );
  }
  if (selectRange) {
    return (
      <RangeCalendar
        className={className}
        date={selectedDate as CalendarRange}
        onChange={onChange}
        min={min}
        max={max}
        onClose={onClose}
      />
    );
  }

  return (
    <SingleCalendar
      className={className}
      date={selectedDate as Date}
      view={view}
      setView={setView}
      tileContent={tileContent}
      onChange={onChange}
      min={min}
      max={max}
      onClose={onClose}
      viewSelector={viewSelector}
    />
  );
}
